module.exports = __webpack_public_path__ + "c6ea01d256fe7fa669844f65be7dd531.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/img/top-img.png
// module id = 1264
// module chunks = 0